import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export const SUBJECTS = {
  teoria_de_voo: {
    id: 'teoria_de_voo',
    name: 'Teoria de Voo',
    image: 'https://images.unsplash.com/photo-1690944210909-9a97ba72a50b?q=80&w=1332&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  conhecimentos_tecnicos: {
    id: 'conhecimentos_tecnicos',
    name: 'Conhecimentos Técnicos de Aeronaves',
    image: 'https://images.unsplash.com/photo-1762846700966-c7784ae77585?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  meteorologia: {
    id: 'meteorologia',
    name: 'Meteorologia',
    image: 'https://images.unsplash.com/photo-1575020363277-3d75a92c961c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxzdG9ybSUyMGNsb3VkcyUyMGFlcmlhbCUyMHZpZXclMjB3ZWF0aGVyJTIwYXZpYXRpb258ZW58MHx8fHwxNzcxNDM5NzgxfDA&ixlib=rb-4.1.0&q=85',
  },
  navegacao_aerea: {
    id: 'navegacao_aerea',
    name: 'Navegação Aérea',
    image: 'https://images.unsplash.com/photo-1762855607111-03c4ded459d0?q=80&w=764&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
  regulamentos: {
    id: 'regulamentos',
    name: 'Regulamentos de Tráfego Aéreo',
    image: 'https://images.unsplash.com/photo-1723059518530-1feec72f2771?q=80&w=1171&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
  },
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const getPercentageColor = (percentage) => {
  if (percentage >= 70) return 'text-emerald-600';
  if (percentage >= 50) return 'text-orange-500';
  return 'text-red-500';
};

export const getPercentageBadge = (percentage) => {
  if (percentage >= 70) return 'badge-success';
  if (percentage >= 50) return 'badge-warning';
  return 'badge-error';
};
